import {computed} from "mobx";
import {DetailsTabModel} from "../details-tab.model";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {CompetitorLinkModel} from "../../../../../containers/competitor-container/models/competitor-link-model";

export class CompetitorIndexPageTabModel extends DetailsTabModel {
  @computed get linkModel(): CompetitorLinkModel {
    const linkModel: CompetitorLinkModel = new CompetitorLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === null;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_scores';
  }
}
